<template>
  <FormDatePicker
    v-if="item.type === 'date'"
    :label="$t(item.label, item.label_props || {})"
    :placeholder="$t(item.label, item.label_props || {})"
    :dateValue.sync="value"
    :dispatchUpdateOnChange="dispatchUpdateOnChange"
    :readonly="!canEdit"
    :disabled="isStudent && item.disable_student"
    :required="item.required"
    :disableClear="item.required"
    disabledActionButtons
    :maxDate="item.is_birth ? birthDateMax : ''"
    :enableInput="item.enable_input"
    :separator="isAppMode(['T21']) ? '/' : '-'"
    :pickerActive="item.is_birth"
    @changed="
      $emit('date-changed', $event)
      $emit('update:fieldValue', $event)
    "
  />
  <FormSelect
    v-else-if="item.is_select"
    :label="$t(item.label, item.label_props || {})"
    :placeholder="$t(item.label, item.label_props || {})"
    :fieldValue.sync="value"
    :dispatchUpdateOnChange="dispatchUpdateOnChange"
    :readonly="!canEdit"
    :disabled="isStudent && item.disable_student"
    :required="item.required"
    :enableClear="!item.required"
    :options="selectOptions"
    :isMultiple="item.is_multiple || false"
    @changed="
      $emit('select-changed', $event)
      $emit('update:fieldValue', $event)
    "
  />
  <FormInput
    v-else
    :type="item.type === 'string' ? 'text' : item.type"
    :label="$t(item.label, item.label_props || {})"
    :placeholder="$t(item.label, item.label_props || {})"
    :fieldValue.sync="value"
    :dispatchUpdateOnChange="dispatchUpdateOnChange"
    :readonly="!canEdit"
    :disabled="isStudent && item.disable_student"
    :required="item.required"
    :isAlphaNumericOnly="item.key === 'hkid' && isAppMode(['T32'])"
    :customRules="_getFieldRules(item.key)"
    @input-value="$emit('input', $event)"
    @changed="$emit('update:fieldValue', $event)"
  >
    <template slot="append-outer" v-if="!isStudent && item.type === 'tel'">
      <WhatsappButton :phone="fieldValue" />
    </template>
  </FormInput>
</template>

<script>
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import FormInput from '@/components/formField/FormInput.vue'
import WhatsappButton from '@/components/WhatsappButton.vue'

export default {
  name: 'Field',
  components: {
    FormDatePicker,
    FormSelect,
    WhatsappButton,
    FormInput,
  },
  props: {
    fieldValue: {
      type: String | Number | Array | Boolean | null,
      required: true,
    },
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    dispatchUpdateOnChange: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    isStudent: {
      type: Boolean,
      default: false,
    },
    selectOptions: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    fieldValue: {
      handler(val) {
        this.value = val
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    birthDateMax() {
      return this.$formatter.formatDate()
    },
  },
  data: () => ({
    value: '',
  }),
  methods: {
    _getFieldRules(key) {
      if (key === 'hkid' && this.isAppMode(['T32'])) {
        return [v => this.gfCheckRule(this.$validate.isValidHKId(v, true))]
      }
      return []
    },
  },
}
</script>
